import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesRevista } from "./imagenesRevista";


function Revista() {
  return <PaginaPublica titulo="Revista" imagenes={imagenesRevista} />;
}

export default Revista;